import { render, staticRenderFns } from "./TextAnalyzer.vue?vue&type=template&id=0ebfbfd9&scoped=true&"
import script from "./TextAnalyzer.vue?vue&type=script&lang=js&"
export * from "./TextAnalyzer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebfbfd9",
  null
  
)

export default component.exports